
























































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { ITableConfig, IFilter, ISorter } from "@/models/tables";
import { DataModules } from "@/store/modules/data";
import { IBulkAction } from "@/models/bulkactions";
import { FilterOperators, FilterTypes, Sorters } from "@/data/table";

@Component
export default class AutomationBulkActionResultsTable extends Mixins(
  FilteringSortingTableStore
) {
  @Prop({ required: true })
  public bulkAction!: IBulkAction;

  public dataModule: string = DataModules.BULK_ACTIONS_RESULTS;

  public defaults: ITableConfig = {
    page: 1,
    limit: this.limit,
    sort: {
      field: "created_at",
      direction: Sorters.ASCENDING
    }
  };

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.date_created")
    },
    {
      field: "successful",
      label: this.$t("_.successful")
    }
  ];

  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.date_created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    },
    {
      key: "successful",
      label: this.$t("_.successful"),
      type: FilterTypes.SELECT_RADIO,
      value: "1",
      operator: FilterOperators.EQUAL
    }
  ];

  public async created() {
    this.getData();
  }

  // override mixin method
  public getStoreParams(payload: any): Promise<any> {
    return { ...payload, id: this.bulkAction.id };
  }

  public getIcon(log) {
    switch (log.successful) {
      case 1: {
        return {
          icon: "check-circle",
          type: "is-success",
          pack: "fas"
        };
      }
      case 0: {
        return {
          icon: "exclamation-circle",
          type: "is-danger",
          pack: "fas"
        };
      }
      default:
        return {
          icon: "info-circle",
          type: "is-info",
          pack: "fas"
        };
    }
  }
}
